import ActionEditor from './ActionEditor'

export default ActionEditor
